/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */
import { fromMarkdown } from 'mdast-util-from-markdown';
/** @type {import('unified').Plugin<[Options?] | void[], string, Root>} */

export default function remarkParse(options) {
  var _this = this;

  /** @type {import('unified').ParserFunction<Root>} */
  var parser = function parser(doc) {
    // Assume options.
    var settings = _this.data('settings');

    return fromMarkdown(doc, Object.assign({}, settings, options, {
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: _this.data('micromarkExtensions') || [],
      mdastExtensions: _this.data('fromMarkdownExtensions') || []
    }));
  };

  Object.assign(this, {
    Parser: parser
  });
}